// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(m) {
  if (m) {
    return "ab_modification_request";
  } else {
    return "simple_modification_request";
  }
}

var ModificationType = {
  toString: toString
};

export {
  ModificationType ,
  
}
/* No side effect */
